<button
  mat-icon-button
  aria-label="Grille de salaires"
  matTooltip="Grille de salaires"
  #trigger="matMenuTrigger"
  [matMenuTriggerFor]="jobMenu"
>
  <fa-icon [icon]="faHandHoldingDollar" class="vanex-gold"></fa-icon>
</button>

<mat-menu #jobMenu="matMenu">
  @for (jobType of jobTypes; track jobType.id) {
    <button mat-menu-item [matMenuTriggerFor]="salaryScalesMenu">{{ jobType.name }}</button>
    <mat-menu #salaryScalesMenu="matMenu">
      @for (salaryScale of salaryScalesByJobTypeId[jobType.id]; track salaryScale.id) {
        <button mat-menu-item (click)="openEditSalaryScaleDialog(jobType, salaryScale)">
          {{ salaryScale.startDate | date: 'd MMMM yyyy' }}
        </button>
      }
      <button
        mat-menu-item
        (click)="openCreateSalaryScaleDialog(jobType)"
        *appHasRole="['cdt-responsable-rh', 'cdt-directeur-rh']"
      >
        <mat-icon>add</mat-icon>
        <span>Ajouter une grille de salaires</span>
      </button>
    </mat-menu>
  }
</mat-menu>
